module.exports = __webpack_public_path__ + "img/certificate-1-1.a63c982c.jpg";